import React, { useState } from 'react';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';
import {
  SelectedColumnsFilters,
  TableColumnHeaderComponentProps,
} from '../types';
import {
  TextInput,
  DatePickerInput,
  NumberInput,
  Button,
} from '@wajeez-web/components/ui';
import { Select } from 'antd';
import { t } from 'i18next';
import { DebounceSearch } from '@wajeez-web/core/utils';

const TableColumnHeaderComponent: React.FC<TableColumnHeaderComponentProps> = ({
  header,
  dataType,
  selectedColumnsFilters,
  setSelectedColumnsFilters,
  id,
  onSort,
  PreferancesData,
  isFilterable,
}) => {
  const booleanOptions = [
    { label: t('selects.labels.True', 'True'), value: 'true' },
    { label: t('selects.labels.False', 'False'), value: 'false' },
  ];
  const handelSelect =
    (parentName: string | number | null, type: string, item: any) =>
    (name: string, value: any) => {
      if (selectedColumnsFilters.find((item) => item.key === parentName)) {
        const selectedIndex: number = selectedColumnsFilters.findIndex(
          (element) => element.key === parentName
        );
        const cols: SelectedColumnsFilters[] = selectedColumnsFilters;
        selectedColumnsFilters[selectedIndex] = {
          ...selectedColumnsFilters[selectedIndex],
          value: type === 'Boolean' ? value : type === 'select' ? value : value,
        };
        setSelectedColumnsFilters(cols);
      } else {
        setSelectedColumnsFilters([
          ...selectedColumnsFilters,
          {
            label: header,
            key: id,
            value:
              type === 'Boolean' ? value : type === 'select' ? value : value,
            type: dataType,
            operator: item.operator,
          },
        ]);
      }
    };
  const { debouncedResults } = DebounceSearch(
    handelSelect(id, 'text', {
      operator: { label: '', value: '2' },
    }),
    300
  );
  const getFilterComponent = () => {
    switch (dataType) {
      case 'String':
        return <TextInput key={header} onChange={debouncedResults} name={id} />;
      case 'Boolean':
        return (
          <Select
            className="input focus:ring-primary  align-middle  focus:ring-4 cursor-pointer  focus:ring-opacity-10 focus:ring-offset-0 rounded-full focus:border-primary block w-full   sm:text-sm border-gray-300 "
            key={header}
            onChange={(value) =>
              handelSelect(id, 'Boolean', {
                operator: { label: '', value: '0' },
              })(id, value)
            }
            value={
              selectedColumnsFilters.length
                ? selectedColumnsFilters.find((ele) => ele.key === id)
                  ? booleanOptions.find(
                      (ele) =>
                        ele.value ===
                        selectedColumnsFilters.find((ele) => ele.key === id)
                          ?.value
                    )
                  : undefined
                : undefined
            }
            options={booleanOptions}
          />
        );
      case 'Date':
        return (
          <DatePickerInput
            key={header}
            onChange={handelSelect(id, 'Date', {
              operator: { label: '', value: 4 },
            })}
            name={id}
            value={
              selectedColumnsFilters.length
                ? selectedColumnsFilters.find((ele) => ele.key === id)?.value ||
                  ''
                : ''
            }
          />
        );
      case 'DateTime':
        return (
          <DatePickerInput
            key={header}
            onChange={handelSelect(id, 'Date', {
              operator: { label: '', value: 4 },
            })}
            // maxDate={new Date()}
            name={id}
            value={
              selectedColumnsFilters.length
                ? selectedColumnsFilters.find((ele) => ele.key === id)?.value ||
                  ''
                : ''
            }
          />
        );
    }
    return <div></div>;
  };
  return (
    <div className="flex flex-col space-y-2 h-full w-full py-3  group">
      <div>{header}</div>
      <div className="flex space-s-2 justify-end font-thin">
        {isFilterable && <div className="w-full">{getFilterComponent()}</div>}
        <div className=" hidden group-hover:block justify-end  text-end ">
          <Button
            onClick={() => {
              onSort &&
                onSort(
                  id,
                  PreferancesData?.sortingOperations?.find(
                    (ele) => ele.property === Number(id)
                  )?.orderByDirection === 1
                    ? 0
                    : 1
                );
            }}
            type="text"
            Icon={
              PreferancesData?.sortingOperations?.find(
                (item) => item.property == Number(id)
              )?.orderByDirection === 0
                ? MdArrowDropDown
                : MdArrowDropUp
            }
            color="textPrimary"
          />
        </div>
      </div>
    </div>
  );
};

export default TableColumnHeaderComponent;
